export
const name: string = "PointCloud";

export
const preproc: string = ``;

export
const declaration: string = `
    attribute vec3  a_position;
    attribute float a_color;

    uniform   mat4  u_view_projection;
    uniform   mat4  u_model_transformation; // this supply the model in model view projectionm matrix as we do not have per mesh model trafo, but met fat model
    uniform   float u_point_size;
`;

export
const varyings: string = `
    varying   vec4  v_mat_diffuse;
`;

export
const implementation: string = `
    void main(void)
    {
        v_mat_diffuse = intToVec4(a_color);
        gl_PointSize  = u_point_size;
        gl_Position   = u_view_projection * u_model_transformation * vec4(a_position, 1.0);

    #ifdef LOGDEPTH
        setVaryingsForLogarithmicDepthBuffer();
    #endif
    }
`;
